module.exports = __webpack_public_path__ + "static/media/Karafarin.13525cc8.svg";